<template>
  <div>
    <ToolbarAuth />
    <Navigation />
    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text"
          >{{ $t("fchart.chart") }} {{ dataext.family_name }}
        </v-card-title>
        <v-simple-table>
          <template v-slot:default>
            <thead></thead>
            <tbody>
              <tr>
                <td class="text-uppercase">{{ $t("users.gender") }}</td>
                <td v-if="dataext.gender === '1'">{{ $t("users.mr") }}</td>
                <td v-if="dataext.gender === '2'">{{ $t("users.mrs") }}</td>
              </tr>
              <tr>
                <td class="text-uppercase">{{ $t("users.first_name") }}</td>
                <td>{{ dataext.first_name }}</td>
              </tr>
              <tr>
                <td class="text-uppercase">{{ $t("users.last_name") }}</td>
                <td>{{ dataext.last_name }}</td>
              </tr>
              <tr>
                <td class="text-uppercase">email</td>
                <td>{{ dataext.email }}</td>
              </tr>
              <tr>
                <td class="text-uppercase">{{ $t("crud.lang") }}</td>
                <td>{{ dataext.language }}</td>
              </tr>


            </tbody>
          </template>
        </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeView()" large class="ma-5" color="accent">
            {{ $t("crud.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import FchartmemberService from "@/services/fchart/FchartmemberService";

export default {
  name: "fchartview",
  components: { ToolbarAuth, Navigation },
  data() {
    return {
      dataext: {},
    };
  },
  methods: {
    getData() {
      let id = this.$route.params.id;
      this.loading = true;
      FchartmemberService.getMain(id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },

    closeView() {
      let id = this.$route.params.famId;
      this.$router.replace({
        name: "fchartMemberIndex",
        params: { famId: id },
      });
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped></style>
